'use client';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import ProductOffer from '../product/ProductOffer';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css/pagination';
import Image from 'next/image';
import { useState, useEffect, useRef } from 'react';
import ProductThumbSlider from '../product/ProductThumbSlider';
import Link from 'next/link';
import { useIsMobile } from '@/app/_hooks/useIsMobile';

export default function ProductsSpecialOffer({ products }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const isMobile = useIsMobile();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const swiperInstance = swiperRef.current;
    prevRef?.current?.addEventListener('click', () => {
      swiperInstance.swiper.slidePrev();
    });

    nextRef?.current?.addEventListener('click', () => {
      swiperInstance.swiper.slideNext();
    });
  }, []);

  return (
    <>
      <div className="container">
        <div
          className="mt-6 p-4 lg:flex items-center"
          style={{
            backgroundImage: "url('/images/special_offer_back.png')",
            backgroundSize: 'contain',
          }}
        >
          <div className="flex justify-between block md:hidden  pb-2 items-center">
            <Image
              src="/images/sepecial-offer-mobile.png"
              width={624}
              height={256}
              alt="offers"
            />
          </div>
          <div className="flex justify-between hidden md:block lg:hidden pb-2 items-center">
            <Image
              src="/images/special-offer-tablet.png"
              width={1376}
              height={256}
              alt="offers"
            />
          </div>
          <div className=" bg-white items-center p-4 rounded-xl max-w-full lg:flex ">
            <div className=" lg:w-1/6 hidden lg:block inline-block text-center hidden flex items-center">
              <Image
                src="/images/special_offer.png"
                width={220}
                height={269}
                alt="offers"
              />
            </div>

            <div className="lg:w-5/6 w-full inline-block">
              <div className=" flex flex-wrap">
                <div className="w-full md:w-7/12 inline-block px-4">
                  <div className="md:border border-light-gray-300 rounded-md md:h-[270px] h-[410px]">
                    <Swiper
                      modules={[Navigation, Thumbs, Autoplay]}
                      thumbs={{
                        swiper:
                          thumbsSwiper && !thumbsSwiper.destroyed
                            ? thumbsSwiper
                            : null,
                      }}
                      autoplay={{
                        delay: 3000, // 5 seconds
                        disableOnInteraction: false, // Continue autoplay after interaction
                      }}
                      speed={1500}
                      loop={true} // Enable looping for continuous sliding
                    >
                      {products.map((product, index) => (
                        <SwiperSlide key={index} style={{ width: 'auto' }}>
                          <ProductOffer product={product} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
                <div className="relative w-full md:w-5/12 flex md:pr-6 overflow-hidden">
                  <div className="flex-1 md:pl-4">
                    <div className=" justify-between hidden md:flex pb-2">
                      <span>دیگر محصولات</span>
                      <Link
                        href="/page/special-offers"
                        className="text-sm text-color-primary font-bold"
                      >
                        مشاهده همه
                      </Link>
                    </div>
                    <Swiper
                      modules={[Thumbs, Autoplay]}
                      watchSlidesProgress
                      onSwiper={setThumbsSwiper}
                      direction={!isMobile ? 'vertical' : 'horizontal'}
                      slidesPerView="auto"
                      spaceBetween={15}
                      className="md:h-[250px] w-[300px] sm:w-[450px] md:w-auto"
                      navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                      }}
                      autoplay={{
                        delay: 3000, // 3 seconds for the thumb slider
                        disableOnInteraction: false,
                      }}
                      speed={1500}
                      ref={swiperRef}
                    >
                      {products.map((product, index) => (
                        <SwiperSlide
                          key={index}
                          style={{ width: 'auto', height: 'auto' }}
                        >
                          <ProductThumbSlider product={product} />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div
                    className={`${
                      isMobile
                        ? 'absolute z-10 top-3 w-full'
                        : 'relative w-[40px]'
                    }  flex justify-between mt-4 rounded-md`}
                  >
                    <div
                      ref={prevRef}
                      className={`${
                        isMobile ? 'left-0' : 'top-0 rotate-90'
                      }  bg-white px-1 cursor-pointer absolute  py-1 rounded-md shadow-sm `}
                    >
                      <CaretLeft />
                    </div>
                    <div
                      ref={nextRef}
                      className={`${
                        isMobile ? 'right-0' : 'bottom-0 rotate-90'
                      }  bg-white px-1 cursor-pointer absolute  py-1 rounded-md shadow-sm `}
                    >
                      <CaretLeft className="rotate-180" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
